jQuery(function( $ ) {
    'use strict'

	const showAjaxDebugLog = false;

    /*
    Required args
    data - must contain an 'action' for WordPress to find wp_admin_%action%()

    Optional args
	onSuccess - success function callback - triggered by wp_send_json_success()
    onError - error function callback - triggered by a server error or wp_send_json_error()
	onComplete - complete function callback - triggered after succes and error handlers

    loadingMessage - optional message text
    successMessage - optional message text
    warningMessage - optional message text
    */

    window.ajaxUrl = function() {
        return ajax_object.ajax_url;
    }

    window.ajaxCall = function( args ) {
        if ( ! args.data ) {
            console.error( 'Ajax Manager - args.data not set in window.ajaxCall');
            return;
        }

        if ( ! args.data['action'] ) {
            console.error( 'Ajax Manager - args.data[action] not set in window.ajaxCall');
            return;
        }

        let startTimestamp,
            endTimestamp,
			notificationId;

        args.data['session_id'] = ajax_object.session_id;
        $.ajax( ajax_object.ajax_url, {
            data: JSON.stringify(args.data),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',

            beforeSend : function() {
				if ( showAjaxDebugLog ) {
					console.log(  'Ajax Manager - Sending request - Action:', args.data['action'] );
					console.log(  args.data );
				}

                notificationId = vmNotificationManager.addInfoNotification( args.loadingMessage, args.loadingNoticeTimeout );
                startTimestamp = Date.now();
            },

            success: function( data ) {
                endTimestamp = Date.now();

                if ( ! data ) {
                    console.error( 'Ajax Manager - Error - missing data for ' + args.data['action'] + '!', args );
                } else if ( data.success ) {
					if ( showAjaxDebugLog ) {
                    	console.log( 'Ajax Manager - Success! - Action:', args.data['action'] );
					}

                    vmNotificationManager.addSuccessNotification( args.successMessage, args.successNoticeTimeout );
                    if ( args.onSuccess ) {
                        args.onSuccess( data );
                    }

                } else {
					const errorMessage = 'message' in data ? data.message : 'data' in data ? data.data : data;
                    console.error( 'Ajax Manager - Error!', args.data['action'], errorMessage );
                    WarningModalManager.show( { message: errorMessage } );
                    vmNotificationManager.addInfoNotification( args.warningMessage, args.warningNoticeTimeout );
                    if ( args.onError ) {
                        args.onError( errorMessage );
                    }
                }
            },

            error: function( data ) {
                endTimestamp = Date.now();

                console.error( 'Ajax Manager - Server Error!', data );
                vmNotificationManager.addErrorNotification( args.warningMessage, args.errorNoticeTimeout );
                if ( args.onError ) {
                    args.onError();
                }
            },

            complete : function( obj, status ) {
                if ( startTimestamp && endTimestamp ) {
                    let millis = endTimestamp - startTimestamp;
                    updateConnectionStatus( millis, status );
                }
				if ( args.onComplete ) {
					args.onComplete();
				}
				vmNotificationManager.removeNotification( notificationId );

                window.undoManager.undoing = false;
                window.undoManager.redoing = false;
            }

        });

    }

    // Connection status speed breakpoints in seconds
    const CONNECTION_STATUS_FAST = 1;
    const CONNECTION_STATUS_MEDIUM = 2;


    // update connection status indicator to show speed and "connection" bars
    function updateConnectionStatus( millis, status ) {
        if ( ! millis || ! status ) {
            console.log( 'Could not set connection status. millis:', millis, '; status:', status, ';' );
            return;
        }

        let connectionStatus = $( '.connection-status' ),
            speedField = $( '.connection-status .speed' ),
            seconds = millis / 1000,
            formattedSpeed = seconds.toFixed(2) + 's';

        sessionStorage.setItem('connectionMillis', millis );
        sessionStorage.setItem('connectionStatus', status );

        speedField.text( formattedSpeed );

        connectionStatus.removeClass( 'fast medium slow success error timeout' );

        if ( seconds < CONNECTION_STATUS_FAST ) {
            connectionStatus.addClass( 'fast' );
        } else if ( seconds < CONNECTION_STATUS_MEDIUM ) {
            connectionStatus.addClass( 'medium' );
        } else {
            connectionStatus.addClass( 'slow' );
        }

        if ( status == 'success' ) {
            connectionStatus.addClass( 'success' );
        } else {
            connectionStatus.addClass( 'error' ); // error or timeout
        }
    }

    // update connection status indicator on load from stored data
    updateConnectionStatus(
        sessionStorage.getItem('connectionMillis' ),
        sessionStorage.getItem('connectionStatus' )
    )

    // refresh connection status indicator on button press
    $( document ).on( 'click', '.connection-test-link', function(e) {
        e.preventDefault();

        let args = {
            data : {
                action: 'connection_test',
            },
            onSuccess : function() {
            },
            onError : function() {
            }
        };

        window.ajaxCall( args );

    });

});
